import React, { useEffect, useRef, useState } from "react";
import { GiNotebook } from "react-icons/gi";
const AnalyticsDashboard = () => {
    const [isloading, setIsloading] = useState(false);
  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-14  ">
          <div className="container mx-auto flex flex-col gap-3 py-6 px-4  sm:px-6 lg:px-8">
            <div className="">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <div className="flex items-center bg-white rounded-lg shadow px-6 py-4 mb-4">
                    <div className="w-10 h-10 bg-gray-300 rounded-full mr-2"></div>
                    <div>
                      <p className="text-mg font-semibold">Analytics & tools</p>
                      <p className="text-[12px] font-normal">
                        Monday, March 31
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow p-6 mb-4">
                    <h2 className="text-lg font-semibold mb-4">Analytics</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">34</p>
                        <p className="text-sm text-gray-600">
                          Post impressions
                        </p>
                        <p className="text-sm text-green-600">
                          ▲ 62% past 7 days
                        </p>
                      </div>

                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">4</p>
                        <p className="text-sm text-gray-600">Followers</p>
                        <p className="text-sm text-gray-600">
                          ● 0% past 7 days
                        </p>
                      </div>

                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">2</p>
                        <p className="text-sm text-gray-600">Profile viewers</p>
                        <p className="text-sm text-gray-600">Past 90 days</p>
                      </div>

                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">3</p>
                        <p className="text-sm text-gray-600">
                          Search appearances
                        </p>
                        <p className="text-sm text-gray-600">Previous week</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow p-6">
                    <div className="border-b border-gray-200 mb-4 ">
                      <h2 className="text-lg font-semibold mb-2">
                        Weekly sharing tracker
                      </h2>
                      <p className="text-sm text-gray-600 mb-4">
                        Increase your visibility by posting or commenting. We
                        suggest taking 3 actions every week.
                      </p>
                    </div>

                    <div className="flex items-center mb-4">
                      <div className="w-16 h-16 bg-white border-2 border-gray-300 rounded-full flex items-center justify-center mr-4">
                        <GiNotebook className="text-4xl text-yellow-500" />
                      </div>
                      <div>
                        <p className="text-[12px] text-gray-600">
                          Mar 31-Apr 6
                        </p>
                        <p className="text-2xl font-bold">
                          0 of 3 <span className="font-normal">actions</span>
                        </p>
                        <p className="text-[14px] text-gray-600">
                          No actions yet. Take 3 actions to achieve the weekly
                          sharing goal.
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">0 <span className="font-normal">posts</span></p>
                        <p className="text-sm text-gray-600 mb-2">
                          Members who post once per week on average see up to 4x
                          more profile views.
                        </p>
                        <a
                          href="#"
                          className="text-blue-600 text-sm font-semibold"
                        >
                          Start a post
                        </a>
                      </div>
                      <div className="border rounded-lg p-4">
                        <p className="text-2xl font-bold">0 <span className="font-normal">comments</span></p>
                        <p className="text-sm text-gray-600 mb-2">
                          Members who comment once per week on average see up to
                          3x more profile views.
                        </p>
                        <a
                          href="#"
                          className="text-blue-600 text-sm font-semibold"
                        >
                          Comment on feed
                        </a>
                      </div>
                    </div>
                    
                  </div>
                  
                </div>

              
                <div className="w-full md:w-64">
                  
                  <div className="bg-white rounded-lg shadow p-4 mb-4">
                    <p className="text-lg font-bold">
                      SEE WHO'S HIRING on LinkUP.
                    </p>
                    
                    <div className="w-full h-32 bg-gray-200 rounded-lg mt-2"></div>
                  </div>

                  
                  <div className="bg-white rounded-lg shadow p-4">
                    <ul className="text-sm">
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          About
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Accessibility
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Help Center
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Privacy & Terms
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Ad Choices
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Advertising
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Business Services
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          Get the LinkedIn app
                        </a>
                      </li>
                      <li className="mb-2">
                        <a
                          href="#"
                          className="text-gray-600 hover:text-blue-600"
                        >
                          More
                        </a>
                      </li>
                    </ul>
                    <div className="flex items-center mt-4">
                      <svg
                        className="w-6 h-6 text-blue-600 mr-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                      </svg>
                      <p className="text-sm text-blue-600 font-semibold">
                        LinkUP Corporation © 2025
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AnalyticsDashboard;